import { Toaster as SonnerToaster, toast } from 'sonner';

/** Toast host, mounted once near the app root. Theme follows the OS setting — this portal has no in-app theme toggle. */
export function Toaster() {
  return (
    <SonnerToaster
      theme="system"
      position="top-right"
      toastOptions={{
        classNames: {
          toast: 'rounded-md border border-border bg-card text-card-foreground shadow-md',
          description: 'text-muted-foreground',
        },
      }}
    />
  );
}

export { toast };
